import { AccountCircle, Close, Phone } from '@mui/icons-material';
import { Grid, Skeleton, styled, Typography } from '@mui/material';
import React from 'react';
import { useCallIdentity } from '../../hooks/use-call-identity';
import { usePhoneWidgetProps } from '../../hooks/use-phone-widget-props';
import { formatUSPhoneNumber } from '../../utils/formatter';
import { CallBox, CallButton, CallHeader, CallStateActive, CloseButton } from './call-styles';

const AnimatedBar = styled(Skeleton)((style) => ({
  backgroundColor: style.theme.palette.success.main,
  position: 'relative',
  height: 12
}));

interface CallHandler {
  (): void;
}

export function CallInboundView(props: {
  phoneNumber: string;
  onIgnore: CallHandler;
  onHangup?: CallHandler;
  onAnswer?: CallHandler;
}) {
  const { contactNames } = useCallIdentity({ phoneNumber: props.phoneNumber });
  const { widgetProps } = usePhoneWidgetProps();

  const showProfile = () => {
    const fireProfile = async () => {
      if (widgetProps && widgetProps.events && widgetProps.events.onPatientProfileClick)
        widgetProps?.events?.onPatientProfileClick(props.phoneNumber);
    };
    fireProfile();
  };

  return (
    <div style={{ position: 'relative' }}>
      <CloseButton onClick={props.onIgnore} variant="xs">
        <Close fontSize="small" />
      </CloseButton>
      <CallBox data-testid="call-inbound">
        <AnimatedBar animation="pulse" variant="rectangular" />
        <CallHeader>
          <Grid container>
            <Grid item xs={6} zeroMinWidth>
              <CallStateActive>INCOMING CALL</CallStateActive>
              <Typography variant="h6" noWrap>
                {contactNames ? contactNames : ''}
              </Typography>
              <Typography variant="body2">{formatUSPhoneNumber(props.phoneNumber)}</Typography>
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'right' }}>
              <CallButton disabled={!contactNames || !contactNames.length} onClick={showProfile}>
                <AccountCircle />
              </CallButton>
              {props.onHangup && (
                <CallButton
                  onClick={props.onHangup}
                  sx={{ backgroundColor: 'rgb(244, 73, 72)', '&:hover': { backgroundColor: 'rgb(244, 73, 72)' } }}
                >
                  <Phone
                    sx={{
                      transform: 'rotate(135deg)'
                    }}
                  />
                </CallButton>
              )}
              {props.onAnswer && (
                <CallButton
                  onClick={props.onAnswer}
                  sx={{ backgroundColor: 'rgb(77, 206, 160)', '&:hover': { backgroundColor: 'rgb(77, 206, 160)' } }}
                >
                  <Phone />
                </CallButton>
              )}
            </Grid>
          </Grid>
        </CallHeader>
      </CallBox>
    </div>
  );
}
